// Recusas de escrita por negócio (CBK-572). O backend não manda campo `code`, então
// a identificação é por status e texto exato, que precisam bater com
// `business/permissions.py` no cakto-backend. Se o texto mudar lá, o caso deixa de
// ser reconhecido e cai no aviso genérico com a mensagem do backend.
export const BUSINESS_FORBIDDEN_DETAIL = {
  FOREIGN: 'O negócio informado não pertence a você.',
  NOT_OWNER: 'Apenas o proprietário do negócio pode executar esta ação.',
  LOCKED:
    'Este negócio ainda não foi aprovado. Ações que alteram dados ou movimentam dinheiro ficam bloqueadas até a aprovação.',
};

export const BUSINESS_FORBIDDEN_REASON = {
  FOREIGN: 'foreign',
  NOT_OWNER: 'not_owner',
  LOCKED: 'locked',
};

export const BUSINESS_HEADER_REFUSED_EVENT = 'cakto:business-header-refused';

export const BUSINESS_HEADER_REFUSED_MESSAGE = 'Você não faz mais parte desse negócio';

const REASON_BY_DETAIL = {
  [BUSINESS_FORBIDDEN_DETAIL.FOREIGN]: BUSINESS_FORBIDDEN_REASON.FOREIGN,
  [BUSINESS_FORBIDDEN_DETAIL.NOT_OWNER]: BUSINESS_FORBIDDEN_REASON.NOT_OWNER,
  [BUSINESS_FORBIDDEN_DETAIL.LOCKED]: BUSINESS_FORBIDDEN_REASON.LOCKED,
};

export const getBusinessForbiddenReason = (error) => {
  if (error?.response?.status !== 403) {
    return null;
  }

  const detail = error.response.data?.detail;

  return typeof detail === 'string' ? REASON_BY_DETAIL[detail.trim()] ?? null : null;
};

export const isBusinessHeaderRefused = (error) =>
  getBusinessForbiddenReason(error) === BUSINESS_FORBIDDEN_REASON.FOREIGN;

export const BUSINESS_CONTEXT_UNAVAILABLE_CODE = 'business_context_unavailable';

const OWNER_ONLY_REASONS = [BUSINESS_FORBIDDEN_REASON.NOT_OWNER, BUSINESS_FORBIDDEN_REASON.LOCKED];

const readRefusal = (error) => {
  const response = error?.response;

  if (response) {
    return { status: response.status, detail: response.data?.detail, code: response.data?.code };
  }

  return { status: error?.status, detail: error?.detail ?? error?.message, code: error?.code };
};

export const getBusinessRefusalMessage = (error) => {
  const { status, detail, code } = readRefusal(error);
  const message = typeof detail === 'string' ? detail.trim() : '';

  if (!message) {
    return null;
  }

  if (status === 409) {
    return code === BUSINESS_CONTEXT_UNAVAILABLE_CODE ? message : null;
  }

  return status === 403 && OWNER_ONLY_REASONS.includes(REASON_BY_DETAIL[message]) ? message : null;
};
